import tileTerzoValico01 from "assets/hard/TERZO-VALICO/01.png";
import tileTerzoValico02 from "assets/hard/TERZO-VALICO/02.png";
import tileTerzoValico03 from "assets/hard/TERZO-VALICO/03.png";
import tileTerzoValico04 from "assets/hard/TERZO-VALICO/04.png";
import tileTerzoValico05 from "assets/hard/TERZO-VALICO/05.png";
import tileTerzoValico06 from "assets/hard/TERZO-VALICO/06.png";
import tileTerzoValico07 from "assets/hard/TERZO-VALICO/07.png";
import tileTerzoValico08 from "assets/hard/TERZO-VALICO/08.png";
import tileTerzoValico09 from "assets/hard/TERZO-VALICO/09.png";
import tileTerzoValico10 from "assets/hard/TERZO-VALICO/10.png";
import tileTerzoValico11 from "assets/hard/TERZO-VALICO/11.png";
import tileTerzoValico12 from "assets/hard/TERZO-VALICO/12.png";
import tileTerzoValico13 from "assets/hard/TERZO-VALICO/13.png";
import tileTerzoValico14 from "assets/hard/TERZO-VALICO/14.png";
import tileTerzoValico15 from "assets/hard/TERZO-VALICO/15.png";
import tileTerzoValico16 from "assets/hard/TERZO-VALICO/16.png";
import tileTerzoValico17 from "assets/hard/TERZO-VALICO/17.png";
import tileTerzoValico18 from "assets/hard/TERZO-VALICO/18.png";
import tileTerzoValico19 from "assets/hard/TERZO-VALICO/19.png";
import tileTerzoValico20 from "assets/hard/TERZO-VALICO/20.png";
import tileTerzoValico21 from "assets/hard/TERZO-VALICO/21.png";
import tileTerzoValico22 from "assets/hard/TERZO-VALICO/22.png";
import tileTerzoValico23 from "assets/hard/TERZO-VALICO/23.png";
import tileTerzoValico24 from "assets/hard/TERZO-VALICO/24.png";
import tileTerzoValico25 from "assets/hard/TERZO-VALICO/25.png";
import tileTerzoValico26 from "assets/hard/TERZO-VALICO/26.png";
import tileTerzoValico27 from "assets/hard/TERZO-VALICO/27.png";
import tileTerzoValico28 from "assets/hard/TERZO-VALICO/28.png";
import tileTerzoValico29 from "assets/hard/TERZO-VALICO/29.png";
import tileTerzoValico30 from "assets/hard/TERZO-VALICO/30.png";
import tileTerzoValico31 from "assets/hard/TERZO-VALICO/31.png";
import tileTerzoValico32 from "assets/hard/TERZO-VALICO/32.png";
import tileTerzoValico33 from "assets/hard/TERZO-VALICO/33.png";
import tileTerzoValico34 from "assets/hard/TERZO-VALICO/34.png";
import tileTerzoValico35 from "assets/hard/TERZO-VALICO/35.png";
import tileTerzoValico36 from "assets/hard/TERZO-VALICO/36.png";
import fullImage from "assets/hard/TERZO-VALICO/complete.png";

import { ILevel, LevelDifficulties, LevelTypes } from "models";

export const terzoValico: ILevel = {
  difficulty: LevelDifficulties.hard,
  type: LevelTypes.roadSign,
  name: "Terzo Valico",
  fullImage,
  successDialogContent: {
    subtitle: "Hai completato la linea del TERZO VALICO",
    link: `https://www.fsitaliane.it/content/fsitaliane/it/opere-strategiche/terzo-valico.html`,
    contents: [
      {
        text: "Riduzione dei ",
        isBold: false,
      },
      {
        text: "tempi di percorrenza",
        isBold: true,
      },
      {
        text: ", potenziamento dei ",
        isBold: false,
      },
      {
        text: "collegamenti con l’Europa",
        isBold: true,
      },
      {
        text: ", sostegno ai ",
        isBold: false,
      },
      {
        text: "commerci marittimi",
        isBold: true,
      },
      {
        text:
          ": sono solo alcuni dei vantaggi legati alla realizzazione della ",
        isBold: false,
      },
      {
        text: "nuova linea del Terzo Valico",
        isBold: true,
      },
      {
        text: ". Un’",
        isBold: false,
      },
      {
        text: "opera strategica",
        isBold: true,
      },
      {
        text:
          " per la mobilità del Paese che consentirà di trasferire quote consistenti di traffico merci dalla strada al ferro. Questo significa non solo ",
        isBold: false,
      },
      {
        text: "trasporti più efficienti",
        isBold: true,
      },
      {
        text:
          ", ma anche un minor impatto sull’ambiente e un forte impulso allo sviluppo economico dell’Italia.",
        isBold: false,
      },
    ],
  },
  tiles: [
    tileTerzoValico01,
    tileTerzoValico02,
    tileTerzoValico03,
    tileTerzoValico04,
    tileTerzoValico05,
    tileTerzoValico06,
    tileTerzoValico07,
    tileTerzoValico08,
    tileTerzoValico09,
    tileTerzoValico10,
    tileTerzoValico11,
    tileTerzoValico12,
    tileTerzoValico13,
    tileTerzoValico14,
    tileTerzoValico15,
    tileTerzoValico16,
    tileTerzoValico17,
    tileTerzoValico18,
    tileTerzoValico19,
    tileTerzoValico20,
    tileTerzoValico21,
    tileTerzoValico22,
    tileTerzoValico23,
    tileTerzoValico24,
    tileTerzoValico25,
    tileTerzoValico26,
    tileTerzoValico27,
    tileTerzoValico28,
    tileTerzoValico29,
    tileTerzoValico30,
    tileTerzoValico31,
    tileTerzoValico32,
    tileTerzoValico33,
    tileTerzoValico34,
    tileTerzoValico35,
    tileTerzoValico36,
  ],
};
